<div class="page-layout">
  <mat-toolbar class="page-toolbar rounded" *ngIf="this.selectedFleet">
    <span>{{ this.selectedFleet.name }}</span>
    <span class="spacer"></span>
    <button mat-raised-button type="button"
            (click)="backToDashboard()">
      <mat-icon>arrow_back</mat-icon>
      Back
    </button>
  </mat-toolbar>

  <div class="gallery-layout rounded">

    <div class="thumbnail-row-wrapper" *ngIf="this.selectedFleet">

      <button mat-icon-button
              type="button"
              class="scroll-button"
              (click)="scrollThumbnails(-1)">
        <mat-icon>chevron_left</mat-icon>
      </button>

      <div class="thumbnail-row" #thumbnailRow>
        <button type="button"
                class="thumbnail-button"
                *ngFor="let project of selectedFleet.projects || []"
                [class.selected]="project === selectedProject"
                (click)="selectProject(project)">

          <img [src]="getImageUrl(selectedFleet.fileName)"
               [alt]="project.name"
               class="thumbnail-image" />
          <div class="thumb-caption">{{ project.name }}</div>
        </button>
      </div>

      <button mat-icon-button
              type="button"
              class="scroll-button"
              (click)="scrollThumbnails(1)">
        <mat-icon>chevron_right</mat-icon>
      </button>

    </div>

    @if (selectedProject) {
      <div class="main-container">
        <p-card class="flex-card" [ngStyle]="{overflow: 'auto'}">
          <div style="max-width: 400px;">
            <mat-form-field>
              <mat-label>Diagram</mat-label>
              <mat-select [(ngModel)]="currentDiagram" (ngModelChange)="updateDiagram(this.currentDiagram)">
                @for (diagram of currentDiagrams; track diagram.id) {
                  <mat-option [value]="diagram">{{ diagram.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          @if (currentDiagram) {
            <div>
              @if (currentDiagram.diagram3dUrls) {
                <div *ngIf="currentDiagram.diagram3d != null">
                  <viewer-3d [modelUrls]="currentDiagram.diagram3dUrls"></viewer-3d>
                </div>
              } @else {
                <div style="position: relative; display: inline-block;">
                  <img style="max-width: 100%" [src]="currentDiagram.imageUrl" />
                  @for (position of currentPositions; track position.id) {
                    <div style="position: absolute; transform: translate(-50%, -90%);"
                         [matTooltip]="position.deviceName"
                         [ngStyle]="{left: position.x * 100 + '%', top: position.y * 100 + '%'}">
                      <svg width="32px" height="32px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"
                           style="z-index: 10;">
                        <path
                          d="M16.001 1.072c5.291 0 9.596 4.305 9.596 9.597 0 1.683-0.446 3.341-1.29 4.799l-8.307 14.394-8.308-14.395c-0.843-1.456-1.289-3.115-1.289-4.798 0-5.292 4.305-9.597 9.597-9.597zM16.001 14.4c2.058 0 3.731-1.674 3.731-3.731s-1.674-3.731-3.731-3.731c-2.058 0-3.732 1.674-3.732 3.731s1.674 3.731 3.732 3.731zM16.001 0.006c-5.889 0-10.663 4.775-10.663 10.663 0 1.945 0.523 3.762 1.432 5.332l9.23 15.994 9.23-15.994c0.909-1.57 1.432-3.387 1.432-5.332 0-5.888-4.774-10.663-10.662-10.663v0zM16.001 13.334c-1.472 0-2.666-1.193-2.666-2.665 0-1.471 1.194-2.665 2.666-2.665s2.665 1.194 2.665 2.665c0 1.472-1.193 2.665-2.665 2.665v0z"
                          style="stroke: #800080; fill: #800080; stroke-width: 2px;">
                        </path>
                      </svg>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </p-card>
        <p-card class="fixed-card">
          <p-table [value]="controlItems"
                   dataKey="projectControlItemId"
                   scrollHeight="calc(100vh - 440px)"
                   [scrollable]="true"
                   [reorderableColumns]="true">

            <ng-template pTemplate="header">
              <tr>
                <th>Control</th>
                <th style="width: 2em;" pTooltip="Implementation Control Statement">IS</th>
                <th style="width: 2em;" pTooltip="Policy &amp; Procedures">PP</th>
                <th style="width: 2em;" pTooltip="Evidence">E</th>
                <th style="width: 2em;" pTooltip="Gaps">G</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
              <tr class="status-row">
                <td [ngStyle]="{'padding-left': item.controlItem.parentControlItemId ? '25px' : '0.5em'}">
                  <i
                    [ngClass]="expandedSmallItem[item.controlItem.controlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"
                    [ngStyle]="{'display': item.subItems && item.subItems.length ? 'inline-block' : 'none'}"></i>
                  {{ item.controlItem.complianceAreaControlId }}
                </td>
                <td style="width: 2em; text-align: center;" class="{{item.implementationStatusStyle}}"></td>
                <td style="width: 2em; text-align: center;"
                    class="{{item.policyNotNeeded ? 'gray' : item.projectControlItemPolicies?.length > 0 ? 'green' : 'red'}}"></td>
                <td style="width: 2em; text-align: center;" class="{{item.evidencesStyle}}"></td>
                <td style="width: 2em; text-align: center; position:relative;" class="{{item.gapStyle}}">
                  <div
                    style="position:absolute;top:0;left:0;right:0;bottom:0;background-color: rgba(255, 255, 255, 0.0001);"
                    [pTooltip]="item.gapCount" tooltipPosition="top"></div>
                </td>
              </tr>
              <tr
                *ngIf="item.subItems.length && !item.controlItem.parentControlItemId && project.isParentContainer && project.displayParentRows">
                <td [ngStyle]="{'padding-left': item.controlItem.parentControlItemId ? '20px' : '0.5em'}">
                  <i *ngIf="item.subItems.length"
                     [ngClass]="expandedSmallItem[item.controlItem.controlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"
                     [ngStyle]="{'display': item.subItems && item.subItems.length ? 'inline-block' : 'none'}"></i>
                  {{ item.controlItem.complianceAreaControlId }}
                </td>
                <td style="width: 2em; text-align: center;"></td>
                <td style="width: 2em; text-align: center;"></td>
                <td style="width: 2em; text-align: center;"></td>
                <td style="width: 2em; text-align: center;"></td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </div>
    } @else {
      <div class="main-container">
        <p-card class="flex-card">
          <img *ngIf="selectedFleet && selectedFleet.fileName"
               [src]="getImageUrl(selectedFleet.fileName)"
               [alt]="selectedFleet.name"
               class="main-image" />
        </p-card>
        <p-card class="fixed-card">
          @if (selectedFleet) {
            <div><strong style="margin-right: 20px;">Fleet Owner:</strong><span>{{selectedFleet.owner}}</span></div>
            <div><strong style="margin-right: 20px;">Last Assessed:</strong><span>{{selectedFleet.lastAssessed | date : 'shortDate'}}</span></div>
            <div><strong style="margin-right: 20px;">Next Assessment:</strong><span>{{selectedFleet.nextAssessment | date : 'shortDate'}}</span></div>
            <div><strong style="margin-right: 20px;">Support Contact:</strong><span>{{selectedFleet.supportContact}}</span></div>
            <div><strong style="margin-right: 20px;">Maintenance:</strong><span>{{selectedFleet.maintenance}}</span></div>
          }
        </p-card>
      </div>
    }
  </div>
</div>
